// extracted by mini-css-extract-plugin
export default {"chat":"chat_chat__LH4Ss","typing_container":"chat_typing_container__7fnrb","typing_dot":"chat_typing_dot__nKhez","loadingFade":"chat_loadingFade__GJ5fu"};